module.exports = __webpack_public_path__ + "img/h54img1.1990e291.png";